import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import __R, { isBasicUser } from 'containers/__R';
import { alert } from 'util/alert';
import locale from './locale';
class StatisticDisplay extends Component {
  navigateToPage(page){
    browserHistory.push(`/${page}/`);
  }
  render(){
    const {data_up_to_now} = this.props.data;
    if(data_up_to_now){
      return (
        <div className='statistic-container block-wrapper'>
          <__R can='student_channel' by='alert' className='r-wrapper'>
            <div className='data-wrapper' onClick={()=>this.navigateToPage('student')}>
              <span className='number'>{data_up_to_now.student_amount}</span>
              <span className='description'>{__('Registered Students', locale)}</span>
            </div>
          </__R>
          <__R can='teacher_channel' by='alert'>
            <div className='data-wrapper' onClick={()=>this.navigateToPage('teacher')}>
              <span className='number'>{data_up_to_now.teacher_amount}</span>
              <span className='description'>{__('Registered Teachers', locale)}</span>
            </div>
          </__R>
          <__R can='class_channel' by='alert'>
            <div className='data-wrapper' onClick={()=>this.navigateToPage('class')}>
              <span className='number'>{data_up_to_now.class_amount}</span>
              <span className='description'>{__('Classes', locale)}</span>
            </div>
          </__R>
          <__R can='private_class_channel' by='alert'>
            <div className='data-wrapper' onClick={()=>this.navigateToPage('one_one')}>
              <span className='number'>{data_up_to_now.private_class_amount}</span>
              <span className='description'>{__('Private Classes', locale)}</span>
            </div>
          </__R>
          <__R can='contact_channel' by='alert'>
            <div className='data-wrapper' onClick={()=> {
              if(isBasicUser()){
                alert.warning(__('Please upgrade to higher subscription plan to unlock this feature', locale))
              }
              else{
                this.navigateToPage('contacts')
              }
              }}>
              <span className='number'>{data_up_to_now.contact_amount}</span>
              <span className='description'>{__('Contacts', locale)}</span>
            </div>
          </__R>
        </div>
      )
    }else {
      return <span></span>
    }

  }
}

export default StatisticDisplay;


// WEBPACK FOOTER //
// ./src/containers/pages/Dashboard/statisticDisplay.js